module.exports = __webpack_public_path__ + "img/icon_zq.282d4e50.png";